// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1guZR","left":"styles_left__1xiw1"};